module.exports = __webpack_public_path__ + "img/design9.80e9bd52.png";